module.exports = __webpack_public_path__ + "media/images/icons/downtown-0efde0bc8f0bd8d831c6170f30b1e8cd.png";